
    import { ElMessage } from 'element-plus';
    import basicApi from '../public/http/index';
    import Constants from '../public/Constants';
    import {
        getLocalStorage,
        setLocalStorage,
        removeLocalStorage
    } from  '../public/storage';
    import { useRouter,onBeforeRouteUpdate  } from 'vue-router';



    // 首先，在 vue 3.0 中，生命周期是从 vue 中导出的，我们需要用到哪些，就导出哪些。
    import {
        defineComponent,
        ref,
        onBeforeMount,
        computed,
        onMounted,
        onBeforeUpdate,
        onUpdated,
        onBeforeUnmount,
        onUnmounted,
        getCurrentInstance,

        reactive
    } from "vue";
    export default {
        name: "login",

        setup() {
            const vcode = reactive({ vcodeid: '', vcode_image: '' });
            const smsCode:any = ref('');
            let showInputSmsDialog:any = ref(false);
            const account = reactive({ name: '', pwd: '', vCode: ''});
            const router = useRouter();
            let disabledStatus:any = ref(false);
            let collegeId: any = ref('');
            let collegeDetail = ref('');

            onMounted(()=>{
                localStorage.removeItem('collegeDetail');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('access_token');
                localStorage.removeItem('user');
                localStorage.removeItem('accountid');
                localStorage.removeItem('background');

                loginInit(router.currentRoute.value)

                // console.log(router.currentRoute.value.query,'router.currentRoute.value.query')
                //
                //     // 跳转带token登录
                //     if(router.currentRoute.value.query?.access_token && router.currentRoute.value.query?.collegeId) {
                //         let access_token: any = router.currentRoute.value.query.access_token;
                //         if(router.currentRoute.value.query.collegeId.length != 24){
                //             ElMessage({
                //                 message:'collegeId参数有误,请重新进入',
                //                 type: 'warning'
                //             });
                //         }else{
                //             setLocalStorage('access_token', access_token);
                //             verifyToken(access_token);
                //             setLocalStorage('collegeId',router.currentRoute.value.query.collegeId);
                //         }
                //     }
                //
                // if(!router.currentRoute.value.query?.collegeId){
                //     disabledStatus.value = true;
                //     alert('请从所属高校就业信息网跳转进行登录！');
                //     console.log(disabledStatus,'disabledStatus')
                // }else {
                //     collegeId.value = router.currentRoute.value.query.collegeId;
                //     setLocalStorage('collegeId',collegeId.value);
                //      get_college_detail();
                // }
                //
                // basicApi.getTopSystemCode().then((res: any) => {
                //     vcode.vcode_image = res.data.vcode_image;
                //     vcode.vcodeid = res.data.vcodeid;
                // }).catch((err: any) => {
                //     console.log('getData', err)
                // });
            });

            const  get_school_security_login = function (accountName: string,collegeId: string) {
                basicApi.school_security_login(accountName,collegeId).then((res)=>{
                    console.log(res,'res')
                    if(res.data.value){
                        setLocalStorage('collegeId',collegeId);
                        let params={
                            login_type: 'username',
                            account_type: 'teacher',
                            username: account.name,
                            password: account.pwd,
                            vcode_verify: {
                                vcodeid:  vcode.vcodeid,
                                vcode_text: account.vCode,
                            },
                            login_source: '高校管理后台',
                        };

                        basicApi.postUserLogin(params).then((res)=>{
                            accountToken(res.data.value);
                        }).catch((err)=>{
                            getSmsCode();
                            account.vCode = '';
                            console.log(err,'rrrr')
                        })
                    }else{
                        ElMessage({
                            message:'账号不属于当前高校，请返回就业信息网重新登录',
                            type: 'warning'
                        });
                    }
                })
            };

            const getSmsCode = function(){
                basicApi.getTopSystemCode().then((res)=>{
                    vcode.vcode_image = res.data.vcode_image;
                    vcode.vcodeid = res.data.vcodeid;
                })
            };

            const userLogin = function(){
                if(!account.name){
                    ElMessage({
                        message:'请输入用户名',
                        type: 'warning'
                    });
                    return
                }

                if(!account.pwd){
                    ElMessage({
                        message:'请输入密码',
                        type: 'warning'
                    });
                    return
                }

                if(!account.vCode){
                    ElMessage({
                        message:'请输入验证码',
                        type: 'warning'
                    });
                    return
                }

                get_school_security_login(account.name,collegeId.value);
            };

            // 获取token
            const accountToken = function(code:string){
                let params={
                    'grant_type': 'authorization_code',
                    'account_type': 'teacher',
                    'code':code
                };
                basicApi.getAccountToken(params).then((res)=>{
                    setLocalStorage('access_token',res.data.access_token);
                    setLocalStorage('refresh_token',res.data.refresh_token);
                    verifyToken(res.data.access_token)
                })
            };

            // 验证token有效
            const verifyToken =  function(access_token: string){
                let params={
                    client_id: Constants.clientId,
                    access_token: access_token
                };
                basicApi.getVerifyToken(params).then((res)=>{
                    if(res.status){
                        verifyAccountIsLock();
                    }
                })
            };

            // 验证 token是否加锁
            const verifyAccountIsLock =  function (){
                basicApi.postVerifyAccountIsLock().then((res)=>{
                    if(!res.data.value){
                        getTeacherInfo();
                    }else {
                        let login_name;
                        let localList:any = window.localStorage;
                        getLocalStorage('safecode_' + account.name) ? login_name =  getLocalStorage('safecode_' + account.name).split('_')[1] : '';
                        for(let i = 0 ; i <localList.length; i++){
                            if(localList.key(i).split('_')[1] == account.name){
                                login_name =localList.key(i).split('_')[1]
                            }
                        }
                        if(login_name){
                            let unlock_access_token = getLocalStorage('safecode_' + account.name);
                            basicApi.post_unlock_access_token(unlock_access_token).then((res)=>{
                                console.log(res,'加锁验证是否通过');
                                getTeacherInfo();
                            })
                        }else {
                            // 当前账号已加锁
                            verifySendSms();
                        }
                    }
                })
            };

            // 安全验证 发送验证码
            const verifySendSms =  function (){
                basicApi.postVerifySendSms().then((res)=>{
                    showInputSmsDialog.value = true;
                })
            };

            // 短信验证码弹窗关闭
            const handleClose =function (){
                removeLocalStorage('access_token');
                removeLocalStorage('refresh_token');
                showInputSmsDialog.value = false;
                getSmsCode();
            };

            // 获取教师信息
            const getTeacherInfo =function (){
                basicApi.getTeacher().then((res)=>{
                    console.log(res.data,'res')
                    if(res.data){
                        setLocalStorage('accountid',res.data.accountid);
                        setLocalStorage('user',res.data);
                        router.push("/home/homepage");
                    }else {
                        // 未获取到教师信息
                    }
                })
            };

            // 获取高校信息
            const get_college_detail = function () {
                let collegeId = getLocalStorage('collegeId');
                basicApi.get_college_detail(collegeId).then((res)=>{
                    console.log(res,'res.data获取高校信息')
                    setLocalStorage('collegeDetail',res.data);
                    collegeDetail.value = res.data;

                })
            }

            // 用户验证码登录
            const userSmsCodeLogin =function (){
                if(!smsCode.value){
                    ElMessage({
                        message:'请输入验证码',
                        type: 'warning'
                    });
                    return
                }
                basicApi.smsCodeLogin(smsCode.value).then((res)=>{
                    if(res.data.value){
                        let user_key;
                        user_key = 'safecode_' + account.name;
                        setLocalStorage(user_key,res.data.value);
                        getTeacherInfo();
                    }
                }).catch((err: any) => {
                    console.log('getData', err);
                    removeLocalStorage('access_token');
                    removeLocalStorage('refresh_token');
                    showInputSmsDialog.value = false;
                });
            };

            //在setup中
            onBeforeRouteUpdate((to) => {
                loginInit(to)
            });

            const  loginInit =function (router: any) {
                getSmsCode();

                console.log('router.query',router.query)
                // 跳转带token登录
                if(router.query?.access_token && router.query?.collegeId) {
                    let access_token: any = router.query.access_token;
                    if(router.query.collegeId.length != 24){
                        ElMessage({
                            message:'collegeId参数有误,请重新进入',
                            type: 'warning'
                        });
                    }else{

                        setLocalStorage('access_token', access_token);
                        verifyToken(access_token);
                        setLocalStorage('collegeId',router.query.collegeId);
                        get_college_detail();

                    }
                }
                else if(!router.query?.collegeId){
                    disabledStatus.value = true;
                    alert('请从所属高校就业信息网跳转进行登录！');
                    console.log(disabledStatus,'disabledStatus')
                }else {
                    if(router.query.collegeId.length != 24){
                        ElMessage({
                            message:'collegeId参数有误,请重新进入',
                            type: 'warning'
                        });
                    }else {
                        collegeId.value = router.query.collegeId;
                        setLocalStorage('collegeId',collegeId.value);
                        get_college_detail();
                    }
                }


            };

            return{
                vcode,
                smsCode,
                account,
                showInputSmsDialog,
                getSmsCode,
                userLogin,
                handleClose,
                userSmsCodeLogin,
                disabledStatus,
                collegeDetail,
            }
        },
    }
